import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Overlay } from '@argo/base-patterns'
import { kbbTheme } from '@argo/themes'
import { ThemeProvider } from '@emotion/react'
import { grayLight30, fontSize2XSmall } from '../../constants/principles'
import { fontSizeLarge, fontWeightBold } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import { getTheme } from '../../constants/themes'
const VerifiedCheckyImage = __PATH_PREFIX__ + '/VerifiedChecky.svg'
const VerifiedByVinImage = __PATH_PREFIX__ + '/VerifiedByVinInfoIcon.svg'

export default ({ text, subheader, children, useArgoStyle, theme }) => {
  const isDesktop = BrowserUtils.isDesktop()
  const [showing, setShowing] = useState(false)
  const message = "To ensure accuracy, most of this vehicle's info has been confirmed by a VIN lookup and manufacturer's build data."
  const { fontFamily, fontWeight } = getTheme(theme) || {}
  
  return (
    <>
      <MainHeader useArgoStyle={useArgoStyle} fontFamily={fontFamily} fontWeight={fontWeight}>
        <TextDivAndIconDiv>
          <TextDisplayDiv
            data-testid={text
              ?.toString()
              .replace(/[^A-Z0-9]/gi, '-')
              .toLowerCase()}
            isDesktop={isDesktop}>
            {text}
          </TextDisplayDiv>
          <IconTable>
            <div height="70%" width="100%"></div>
            <IconEmptyRow> </IconEmptyRow>
            <IconRow>
              {(text === 'Edit Offer' || text === 'Review Offer') && (
                <VerifiedByIconTextAndIconDiv>
                  <VerifiedByIconDiv>
                    <StyledCheckmarkIcon src={VerifiedCheckyImage} alt="checkmark" />
                  </VerifiedByIconDiv>
                  <VerifiedByIconTextDiv>Verified by VIN</VerifiedByIconTextDiv>
                  {text !== 'Review Offer' && (
                    <VerifiedByIconDiv>
                      <ThemeProvider theme={kbbTheme}>
                        <Overlay showOverlay={showing} header="Verified by VIN" headingStyle="SubsectionHeadingSemi" headingTag="h4" enableTitleCase="false" widthRatio="75" maxHeightRatio="60" maxWidth="100px" onClose={() => setShowing(false)}>
                          {message}
                        </Overlay>
                      </ThemeProvider>
                      <StyledInfoIcon src={VerifiedByVinImage} alt="information" onClick={() => setShowing(true)} />
                    </VerifiedByIconDiv>
                  )}
                </VerifiedByIconTextAndIconDiv>
              )}
            </IconRow>
          </IconTable>
        </TextDivAndIconDiv>
        {subheader && <SubHeader>{subheader}</SubHeader>}
        {children}
      </MainHeader>
    </>
  )
}

const MainHeader = styled.h1`
  margin-bottom: 8px;
  width: 100%;
  margin: 0px;
  ${p =>
    !p.useArgoStyle
      ? `
    font-size: ${fontSizeLarge};
    text-align: left;
    font-weight: ${fontWeightBold};
    padding: 16px 0 8px 0;
    border-bottom: 6px solid ${grayLight30};
    `
      : `
    font-family: "Montserrat",sans-serif;
    font-size: 36px;
    line-height: 40px;
    font-weight: 800;
    `}
  ${p => (p.fontFamily ? `font-family: ${p.fontFamily};` : '')};
  font-weight: ${props => props.fontWeight?.bold || fontWeightBold};
`

const SubHeader = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: normal;
  margin: 0px;
`
const TextDivAndIconDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`
const TextDisplayDiv = styled.div`
  display: flex;
  text-align: left;
  width: ${p => (!p.isDesktop ? '300%' : '50%')};
  flex-direction: row;
`
const IconTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`
const IconEmptyRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50%;
`
const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50%;
`

const VerifiedByIconTextAndIconDiv = styled.div`
  width: 100%;
  display: flex;
  vertical-align: bottom;
  text-align: right;
  height: 100%;
  justify-content: right;
`
const VerifiedByIconDiv = styled.div`
  display: flex;
  text-align: center;
`
const VerifiedByIconTextDiv = styled.div`
  display: flex;
  text-align: left;
  font-size: 13px;
`
const StyledCheckmarkIcon = styled.img`
  height: 15px;
  margin-right: 5px;
`

const StyledInfoIcon = styled.img`
  height: 20px;
  margin-left: 5px;
`
